// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const SlackBwIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M5.62 14.9a2.31 2.31 0 0 1-4.62 0 2.3 2.3 0 0 1 2.31-2.31h2.3zM6.78 14.9a2.31 2.31 0 0 1 4.62 0v5.78a2.31 2.31 0 0 1-4.62 0zM9.1 5.62A2.31 2.31 0 0 1 9.1 1a2.3 2.3 0 0 1 2.31 2.31v2.3zM9.1 6.78a2.31 2.31 0 0 1 0 4.63H3.31a2.31 2.31 0 0 1 0-4.62zM18.38 9.1a2.31 2.31 0 0 1 4.62 0 2.3 2.3 0 0 1-2.3 2.31h-2.32zM17.22 9.1a2.31 2.31 0 0 1-4.62 0V3.31a2.31 2.31 0 0 1 4.62 0zM14.9 18.38a2.31 2.31 0 0 1 0 4.62 2.3 2.3 0 0 1-2.31-2.31v-2.3zM14.9 17.22a2.31 2.31 0 0 1 0-4.62h5.78a2.31 2.31 0 0 1 0 4.62z"
    />
  </svg>,
  "SlackBw",
);
export default SlackBwIcon;
